import { render } from "./detailXyHis.vue?vue&type=template&id=abaf5588"
import script from "./detailXyHis.vue?vue&type=script&lang=js"
export * from "./detailXyHis.vue?vue&type=script&lang=js"

import "./detailXyHis.vue?vue&type=style&index=0&id=abaf5588&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__